import React from 'react'
import { StyledComponent } from '@emotion/styled'
import { Box, BoxProps, styled, Theme } from '@mui/material'
import { StandardLonghandProperties } from 'csstype'

type PaletteColor = 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error'

type MarkerProps = BoxProps & {
  color: PaletteColor | StandardLonghandProperties['backgroundColor'];
  size?: number;
}

const Marker: StyledComponent<MarkerProps> = styled((props: MarkerProps) => (
  <Box {...props} component='span' />
))(
  ({ theme: { spacing, palette }, color, size = 14 }: MarkerProps & { theme: Theme }) => ({
    display: 'inline-flex',
    backgroundColor: palette[color as PaletteColor] ? palette[color as PaletteColor].main : color,
    marginRight: spacing(0.75),
    borderRadius: '50%',
    height: size,
    width: size,
  })
)

export default Marker